import React, { useEffect, useState } from 'react';
import ConvivaLogo from '@src/images/conviva_logo.svg';
import { ConnectingText, ConnectingWarpper } from './styles';

const WaitingForConnection = () => {
  const [dotCount, setDotCount] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev % 3) + 1);
    }, 500); // Change every 0.5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <ConnectingWarpper>
      <ConvivaLogo style={{ fontSize: 90 }} />
      <ConnectingText>Waiting for connection{'.'.repeat(dotCount)}</ConnectingText>
    </ConnectingWarpper>
  );
};

export default WaitingForConnection;
